import { createIcon } from '@chakra-ui/react';

export const Religion = createIcon({
  displayName: `Religion`,
  viewBox: `0 0 45.155 45.155`,
  path: (
    <g transform="translate(-1033.107 309.527)">
      <path
        d="M1072.027-300.977l1.791,3.629,4.005.582-2.9,2.825.684,3.989-3.582-1.883-3.582,1.883.684-3.989-2.9-2.825,4.005-.582Z"
        transform="translate(-7.646 -1.751)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.5"
      />
      <g transform="translate(1034.357 -308.277)">
        <path
          d="M1060.707-274.779a17.194,17.194,0,0,1-17.194-17.195,17.2,17.2,0,0,1,11.734-16.3,21.329,21.329,0,0,0-20.89,21.322,21.333,21.333,0,0,0,21.333,21.333,21.329,21.329,0,0,0,21.322-20.89A17.2,17.2,0,0,1,1060.707-274.779Z"
          transform="translate(-1034.357 308.277)"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2.5"
        />
      </g>
    </g>
  ),
});
